import { ExternalLink } from 'react-feather'
import { useFileUrl } from './FileUrlContext'
import { MarkdownText } from './MarkdownText'

export function ReportCard({ title, description, href, thumbnailId, buttonText = 'Read report', headingLevel = 1 }: {
  title: string
  description?: string | null
  href?: string | null
  thumbnailId?: string | null
  buttonText?: string | null
  headingLevel?: 1 | 2
}) {
  const fileUrl = useFileUrl()
  const thumbnailSrc = thumbnailId ? fileUrl(thumbnailId) : null
  const Heading = headingLevel === 1 ? 'h1' : 'h2'

  return (
    <section className="card rf-pop-in mx-auto overflow-hidden" style={{ maxWidth: 720 }} aria-label="Report">
      {thumbnailSrc && (
        <div style={{ aspectRatio: '16 / 9', background: 'var(--color-surface-2)', overflow: 'hidden' }}>
          <img src={thumbnailSrc} alt="" loading="eager"
            onError={(e) => { e.currentTarget.parentElement?.setAttribute('hidden', '') }}
            style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
      )}
      <div style={{ padding: 'clamp(22px, 4.5vw, 30px)' }}>
        <Heading style={{ color: 'var(--color-ink)', fontSize: 'clamp(22px, 5vw, 30px)', lineHeight: 1.14, textWrap: 'balance' }}>{title}</Heading>
        {description && (
          <MarkdownText style={{ marginTop: 'clamp(14px, 2.5vw, 18px)', color: 'var(--color-ink-2)', fontSize: 14.5, lineHeight: 1.55 }}>{description}</MarkdownText>
        )}
        <div className="flex" style={{ marginTop: 'clamp(18px, 3vw, 22px)' }}>
          {href ? (
            <a href={href} target="_blank" rel="noopener noreferrer" className="btn btn--primary inline-flex"
              style={{ width: '100%', minHeight: 48 }}
              aria-label={`${buttonText || 'Read report'}: ${title} (opens in a new tab)`}>
              {buttonText || 'Read report'} <ExternalLink size={16} color="var(--color-on-primary)" />
            </a>
          ) : (
            <button className="btn btn--primary" style={{ width: '100%', minHeight: 48 }} type="button" disabled>Report is being prepared</button>
          )}
        </div>
      </div>
    </section>
  )
}
